<template>
  <form>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Nom</span>
      </div>
      <input :value="equipe.nom"
             name="equipe_nom"
             disabled
             type="text"
             class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-append">
        <span class="input-group-text">Slogan</span>
      </div>
      <input :value="equipe.slogan"
             name="equipe_slogan"
             disabled
             type="email"
             class="form-control"
             placeholder="Adresse email" >
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Date de création de l'équipe</span>
      </div>
      <input :value="equipe.date_creation_equipe"
             name="equipe_date_creation_equipe"
             disabled type="text"
             class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Championnat</span>
      </div>
      <select name="equipe_championnat"
              disabled
              class="custom-select">
        <option>{{ (championnat && championnat.nom) ? championnat.nom : '' }}</option>
</select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Classement</span>
      </div>
      <select name="equipe_classement"
              disabled
              class="custom-select">
        <option>{{ (classement && classement.position) ? classement.position : '' }}</option>
</select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Totem</span>
      </div>
      <input :value="equipe.totem"
             name="equipe_totem"
             disabled
             type="text"
             class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Historique</span>
      </div>
      <textarea :value="equipe.historique"
                name="equipe_historique"
                disabled
                type="text"
                class="form-control">
      </textarea>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Noms du président</label>
      </div>
      <input :value="equipe.nom_complet_president"
             class="form-control"
             name="equipe_nom_complet_president"
             disabled
             type="text">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Téléphones du président</label>
        <label class="input-group-text"></label>
      </div>
      <input :value="equipe.telephones_president"
             class="form-control"
             name="equipe_president_telephone_1"
             disabled
             type="tel">
      <input :value="equipe.telephones_president"
             class="form-control"
             name="equipe_president_telephone_2"
             disabled
             type="tel">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Noms du serétaire</label>
      </div>
      <input :value="equipe.nom_complet_secretaire"
             class="form-control"
             name="equipe_nom_complet_secretaire"
             disabled
             type="text">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Téléphones du président</label>
        <label class="input-group-text"></label>
      </div>
      <input :value="equipe.telephones_secretaire"
             class="form-control"
             name="equipe_secretaire_telephone_1"
             disabled
             type="tel">
      <input :value="equipe.telephones_secretaire"
             class="form-control"
             name="equipe_secretaire_telephone_2"
             disabled
             type="tel">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Date et Temps de creation</span>
      </div>
      <input :value="equipe.date_creation"
             name="equipe_date_creation"
             disabled
             type="date"
             class="form-control">
      <input :value="equipe.temps_creation"
             name="equipe_temps_creation"
             disabled
             type="time"
             class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Date et Temps de mise à jour</span>
      </div>
      <input :value="equipe.date_modification"
             name="equipe_date_modification"
             disabled
             type="date"
             class="form-control">
      <input :value="equipe.temps_modification"
             name="equipe_temps_modification"
             disabled
             type="time"
             class="form-control">
    </div>
  </form>
</template>

<script>
import {mapMutations, mapActions, mapGetters} from 'vuex'

export default {
  name: "Read",
  props: {
    equipe: {
      type: Object
    }
  },
  data(){
    return{
      championnat: null,
      classement: null,
    }
  },
  components: {},
  methods: {
    ...mapMutations([]),
    ...mapActions([
      'axiosGetAllData',
      'axiosGetOneData'
    ]),
  },
  computed: {
    ...mapGetters([])
  },
  beforeCreate() {},
  created() {
    //
    this.axiosGetOneData({
      table: "championnats",
      table_id: this.equipe.championnat_id
    })
        .then( (data) => {
          this.championnat = data.data
        })
        .catch( (error) => {

        })
    //
    this.axiosGetAllData({
      table: "classements",
    })
        .then( (data) => {
          const classements = data.data
          this.classement = classements.filter((classement) => classement.equipe_id === this.equipe.equipe_id)[0]
        })
        .catch( (error) => {

        })
  },
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {}
}
</script>

<style lang="scss" scoped>
form{
  & > div{
    & > div{
      & > span, & > label{
        background-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
        color: var(--color-white, rgba(255, 255, 255, 1));
        border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
      }
      & > span.customized-span{
        padding: 0.25rem 0.5rem;
        font-size: 0.875rem;
        line-height: 1.5;
        border-radius: 0.2rem;
      }
    }
    & > input, & > select{
      border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/equipes/components/Read.vue